//SLVI-1334-INICIO
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import Spinner from '../../components/Spinner';
import Logo from '../../assets/porto-seguro-logo-2.png';
import './style.scss';

const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
};

export default function ValidarLogin() {
    const history = useHistory();
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [feedback, setFeedback] = useState(null); // 'success' | 'error' | null

    const [loadingAuthz, setLoadingAuthz] = useState(false);
    const [authzFeedback, setAuthzFeedback] = useState(null); // 'success' | 'error' | 'no-token' | null

    const handleSubmit = async (e) => {
        e.preventDefault();
        setFeedback(null);
        setLoading(true);

        try {
            const response = await axios.post('/auth/colws', { userName, password });
            const { resultCode, sessionToken } = response.data;

            if (resultCode === 'LOGIN_SUCCESS') {
                console.log('sucesso');
                document.cookie = `sessionToken=${sessionToken}; path=/; SameSite=Strict`;
                localStorage.setItem('colwsLoginValido', 'true');
                history.push('/');
            } else {
                console.log('falha');
                setFeedback('error');
            }
        } catch (error) {
            console.log('falha');
            setFeedback('error');
        } finally {
            setLoading(false);
        }
    };

    const handleAuthorize = async () => {
        setAuthzFeedback(null);
        const sessionToken = getCookie('sessionToken');

        if (!sessionToken) {
            setAuthzFeedback('no-token');
            return;
        }

        setLoadingAuthz(true);
        try {
            const response = await axios.post('/auth/colws/authz', { sessionToken });
            const { resultCode } = response.data || {};

            if (resultCode === 'AUTHORIZED') {
                setAuthzFeedback('success');
            } else if (resultCode === 'NOTAUTHORIZED') {
                setAuthzFeedback('error');
            } else {
                setAuthzFeedback('error');
            }
        } catch (error) {
            setAuthzFeedback('error');
        } finally {
            setLoadingAuthz(false);
        }
    };

    return (
        <div id="validar-login">
            <div className="modalLoaderErro off">
                <div className="content">
                    <Spinner />
                </div>
            </div>

            <div className="validar-login-container">
                <img src={Logo} alt="Porto Seguro" className="validar-login-logo" />
                <h2>Validar Login</h2>

                <form onSubmit={handleSubmit} className="validar-login-form">
                    <div className="input-field">
                        <input
                            type="text"
                            id="userName"
                            placeholder=" "
                            value={userName}
                            onChange={(e) => setUserName(e.target.value)}
                            required
                        />
                        <label htmlFor="userName">Usuário</label>
                    </div>

                    <div className="input-field">
                        <input
                            type="password"
                            id="password"
                            placeholder=" "
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <label htmlFor="password">Senha</label>
                    </div>

                    {feedback === 'success' && (
                        <p className="feedback feedback--success">Login validado com sucesso!</p>
                    )}
                    {feedback === 'error' && (
                        <p className="feedback feedback--error">Usuário ou senha inválidos.</p>
                    )}

                    <button
                        type="submit"
                        className="btn-primary btn-confirmar"
                        disabled={loading}
                    >
                        {loading ? 'Verificando...' : 'Confirmar'}
                    </button>
                </form>
            </div>
        </div>
    );
}
//SLVI-1334-FIM
